import { render, staticRenderFns } from "./userAdministration.vue?vue&type=template&id=45049c08&scoped=true&"
import script from "./userAdministration.vue?vue&type=script&lang=js&"
export * from "./userAdministration.vue?vue&type=script&lang=js&"
import style0 from "./userAdministration.vue?vue&type=style&index=0&id=45049c08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45049c08",
  null
  
)

export default component.exports